import React from 'react';

import { CustomTextArea } from './styles';

export default function TextArea(props) {
   return (
      <CustomTextArea {...props} />
   )
}
